import { DecisionContext, defaultFinancialYear } from "../common/commonDomain";
import { makeAutoObservable } from "mobx";
import { DecisionType } from "../../common/decisions";
import { BooleanFieldModel, LocalDateFieldModel, NumberFieldModel } from "../../common/commonForms";

export type ApproveAnnualAccount = {
  type: DecisionType.approveAnnualAccount;
  isDeviatingPeriod?: boolean;
  deviatingPeriodFrom?: string;
  deviatingPeriodTo?: string;
  period?: string;
  isSmallBusinesses?: boolean;
  isGroup?: boolean;
};

export class ApproveAnnualAccountForm {
  readonly type = DecisionType.approveAnnualAccount;
  isDeviatingPeriod: BooleanFieldModel;
  deviatingPeriodFrom: LocalDateFieldModel;
  deviatingPeriodTo: LocalDateFieldModel;
  period: NumberFieldModel;
  isSmallBusinesses: BooleanFieldModel;
  isGroup: BooleanFieldModel;

  constructor(
    private context: DecisionContext,
    public data?: ApproveAnnualAccount,
  ) {
    this.isDeviatingPeriod = new BooleanFieldModel({
      value: data?.isDeviatingPeriod,
      required: true,
    });
    this.deviatingPeriodFrom = new LocalDateFieldModel({ value: data?.deviatingPeriodFrom });
    this.deviatingPeriodTo = new LocalDateFieldModel({ value: data?.deviatingPeriodTo });
    this.period = new NumberFieldModel({
      value: Number(data?.period || defaultFinancialYear()),
      isPositiveOrZero: true,
      isInteger: true,
      disableFormatting: true,
      required: true,
    });
    this.isSmallBusinesses = new BooleanFieldModel({
      value: data?.isSmallBusinesses,
      required: true,
    });
    this.isGroup = new BooleanFieldModel({ value: data?.isGroup, required: true });
    makeAutoObservable(this);
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }

  get isValid() {
    return (
      this.isDeviatingPeriod.isValid &&
      this.deviatingPeriodFrom.isValid &&
      this.deviatingPeriodTo.isValid &&
      this.period.isValid &&
      this.isSmallBusinesses.isValid &&
      this.isGroup.isValid
    );
  }

  validate(): boolean {
    this.isDeviatingPeriod.validate();
    this.isSmallBusinesses.validate();
    this.isGroup.validate();
    return this.isValid;
  }
}
